export enum SocialNetworkPrivacy {
  PUBLIC = 'PUBLIC',
  INVITE_ONLY = 'INVITE_ONLY',
  PUBLIC_READ = 'PUBLIC_READ',
}
